export default {
  default: {
    welcome: 'Hello anh em han quoc',
  },
};
